import { useTranslation } from 'react-i18next';
import {
  ReportStatePanel,
  type ReportStateVariant,
} from './ReportStatePanel/ReportStatePanel';
import classes from './ReportErrorState.module.css';

interface IReportErrorStateProps {
  titleKey: string;
  descriptionKey?: string;
  retryLabelKey: string;
  onRetry: () => void;
  /** `compact` renders the inline section-card treatment (default: full page). */
  variant?: ReportStateVariant;
}

/** Shared error state for analytics report pages — alert icon + retry button. */
export function ReportErrorState({
  titleKey,
  descriptionKey,
  retryLabelKey,
  onRetry,
  variant = 'default',
}: IReportErrorStateProps) {
  const { t } = useTranslation();
  return (
    <ReportStatePanel
      icon="alert"
      variant={variant}
      titleKey={titleKey}
      {...(descriptionKey ? { descriptionKey } : {})}
      action={
        <button
          type="button"
          className={classes.retryButton}
          onClick={onRetry}
        >
          {t(retryLabelKey)}
        </button>
      }
    />
  );
}
